export const products = [
  // Raw Materials
  {
    id: 1,
    name: "Tender Coconut Husk",
    category: "Raw Materials",
    image: "/Product Images/Tender Coconut Husk.jpg",
    description: "Premium quality tender coconut husk, perfect for processing into various coir products. Fresh and sustainably sourced."
  },
  {
    id: 2,
    name: "Coco Raw Fiber",
    category: "Raw Materials",
    image: "/Product Images/Coco Raw Fiber.jpg",
    description: "High-quality raw coir fiber extracted from coconut husks. Ideal for manufacturing ropes, mats, and other coir products."
  },
  {
    id: 3,
    name: "Coco Pith Powder",
    category: "Raw Materials",
    image: "/Product Images/Coco Pith Powder.jpg",
    description: "Fine coco pith powder, excellent for horticultural applications. Great water retention and aeration properties."
  },
  {
    id: 4,
    name: "Low EC Cocopeat Block",
    category: "Raw Materials",
    image: "/Product Images/Low EC Cocopeat Block.jpg",
    description: "Premium low EC (Electrical Conductivity) cocopeat blocks. Perfect for hydroponic and greenhouse cultivation."
  },
  
  // Finished Products
  {
    id: 5,
    name: "Coir Rope",
    category: "Finished Products",
    image: "/Product Images/Coir Rope.jpg",
    description: "Strong and durable coir rope made from premium coconut fiber. Available in various thicknesses and lengths."
  },
  {
    id: 6,
    name: "Coco Pole Stick",
    category: "Finished Products",
    image: "/Product Images/Coco Pole Stick.jpg",
    description: "Natural coco pole sticks for plant support. Eco-friendly and biodegradable alternative to synthetic supports."
  },
  
  // Machinery
  {
    id: 7,
    name: "Coir Fiber Extraction Machine",
    category: "Machinery",
    image: "/Product Images/Coir Fiber Extraction Machine.jpg",
    description: "Efficient coir fiber extraction machine for processing coconut husks. High productivity and low maintenance."
  },
  {
    id: 8,
    name: "2 Ply Coir Rope Machine",
    category: "Machinery",
    image: "/Product Images/2 Ply Coir Rope Machine.jpg",
    description: "Advanced 2-ply coir rope making machine. Produces high-quality ropes with consistent thickness and strength."
  },
  {
    id: 9,
    name: "Cocopeat Screener",
    category: "Machinery",
    image: "/Product Images/Cocopeat Screener.jpg",
    description: "Professional cocopeat screening machine for separating and grading cocopeat particles. Ensures uniform quality."
  }
];

export const categories = ["All", "Raw Materials", "Finished Products", "Machinery"];

